import {mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters('async', [
      'customer_functions_hash',
      'expense_natures_hash',
      'mapping_customer_types_hash',
      'item_types_hash',
      'fund_usages_hash',
      'title_mappings',
      'title_mappings_hash',
      'analysis_titles_hash',
      'account_titles_hash',
    ]),
  },
  methods: {
    titleNamesByTitleMapping(title_mapping_id) {
      if (!title_mapping_id) {
        return '无';
      }
      const tm = this.title_mappings_hash[title_mapping_id];
      if (!tm) {
        return '未找到指定配置';
      }
      const account_title = this.account_titles_hash[tm.account_title_id];
      const account_text = account_title ? account_title.full_name : '未找到会计科目';
      const analysis_title = this.analysis_titles_hash[tm.analysis_title_id];
      const analysis_text = analysis_title ? analysis_title.full_name : '未找到分析科目';
      return `[会计科目 ${account_text}] [分析科目: ${analysis_text}]`;
    }
  }
}
